'use client'
import React, { ReactNode } from 'react'

import styles from './styles.module.scss'
import { NavLink } from '../../NavLink'

interface TabsProps {
  tabs: {
    link: string
    text: string
    count?: number
    icon?: ReactNode | null
  }[]
}
const Tabs: React.FC<TabsProps> = ({ tabs }) => {
  return (
    <div className={styles.container}>
      <div className={styles.tabs}>
        {tabs.map((tab, idx) => (
          <NavLink
            key={`${tab.link}${idx}`}
            className={`${styles.tab} ${tab.count ? styles.withCounts : ''}`}
            href={tab.link}
            activeClassName={styles.active}
          >
            {tab.text}
            {tab.count && tab.count > 0 ? (
              <div className={styles.count}>{tab.count}</div>
            ) : null}
            {tab.icon}
          </NavLink>
        ))}
      </div>
    </div>
  )
}

export default React.memo(Tabs)
